var map = {
	"./bfs/app/shared/dso-selector/modal-wrappers/edit-collection-selector/edit-collection-selector.component": [
		90889
	],
	"./custom/app/shared/dso-selector/modal-wrappers/edit-collection-selector/edit-collection-selector.component": [
		90627,
		"src_themes_custom_app_shared_dso-selector_modal-wrappers_edit-collection-selector_edit-collec-d105b5"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 61130;
module.exports = webpackAsyncContext;